import { Button, Form, Input, message } from "antd";
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import API from "../../config/api";
import { POST } from "../../utils/apiCalls";

function AdminChangePassword() {
  const [isLoading, setIsLoading] = useState(false);
  const User = useSelector((state: any) => state.User);
  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    try {
      setIsLoading(true);
      const response: any = await POST(API.ADMIN_FORGOT_PASSWORD, {
        email: values?.email,
      });

      if (response?.status) {
        message.success(
          response.message || "Password reset link has been sent to your email"
        );
        form.resetFields();
      } else {
        message.error(
          response?.message || "Failed to send reset link. Please try again."
        );
      }
    } catch (err) {
      console.error("Error:", err);
      message.error("Failed to send reset link. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{ minHeight: "80vh", display: "flex", flexDirection: "column" }}
    >
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Container>
          <Row style={{ justifyContent: "center" }}>
            <Col sm={4} xs={12}>
              <div
                style={{
                  padding: "40px",
                  background: "#fff",
                  borderRadius: "8px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                }}
              >
                <div
                  style={{
                    fontSize: "24px",
                    fontWeight: "bold",
                    textAlign: "center",
                    marginBottom: "24px",
                  }}
                >
                  Reset Password
                </div>
                <Form form={form} onFinish={onFinish} layout="vertical">
                  <Form.Item
                    name="email"
                    rules={[
                      { required: true, message: "Please enter your email" },
                      { type: "email", message: "Please enter a valid email" },
                    ]}
                    initialValue={User?.user?.email}
                  >
                    <Input
                      defaultValue={User?.user?.email}
                      placeholder="Enter your email"
                      size="large"
                      type="email"
                      disabled
                    />
                  </Form.Item>
                  <Form.Item>
                    <Button
                      block
                      type="primary"
                      htmlType="submit"
                      size="large"
                      loading={isLoading}
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default AdminChangePassword;
